<template>
  <div id="basic">
    <div class="top_div">
      <el-form :inline="true" :model="formInline">
        <el-form-item label="请选择门店" style="margin-right:20px">
          <el-select v-model="formInline.shop_id" placeholder="请选择" @change="getList">
            <el-option
              v-for="index in typeDate"
              v-bind:key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" placeholder="请选择">
           <el-option
               
                label="不限制"
                value=""
              ></el-option>
            <el-option
              v-for="index in statusList"
              v-bind:key="index.id"
              :label="index.value"
              :value="index.key_name"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="demo-form-inline">
          <el-form-item label="按起止时间:">
            <el-date-picker
              v-model="formInline.date"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="微信昵称">
            <el-input v-model="formInline.client_nick_name"></el-input>
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input v-model="formInline.mobile"></el-input>
          </el-form-item>
        </div>

        <div class="bottom_center">
          <el-form-item style="min-width: 150px;">
            <el-button type="primary" style="background: #1890ff;" @click="getList">查询</el-button>
            <el-button type="primary" class="vubutton" @click="onSubmit">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
      <el-table
        :fit="false"
        border
        :data="tableData"
        style="width: auto;"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>

        <el-table-column label="微信名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.nick_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系方式" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column label="退款状态" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.status }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付方式" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.reason}}</span>
          </template>
        </el-table-column>

        <el-table-column label="订单类型" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.order_type}}</span>
          </template>
        </el-table-column>
        <el-table-column label="退款金额" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.refund_fee/100}}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.updated_at }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="refundValue(scope.row.id)">查看</el-button>
            <el-button v-if="scope.row.status==='申请退款'" @click="deleteLaole(scope.row.id)">退款</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="pageSize"
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="page_size"
      ></el-pagination>
    </div>
    <el-dialog title="详细信息" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="微信名称：" :label-width="formLabelWidth">
          <div>{{form.nick_name}}</div>
        </el-form-item>
        <el-form-item label="联系方式：" :label-width="formLabelWidth">
          <div>{{form.mobile}}</div>
        </el-form-item>
        <el-form-item label="支付方式：" :label-width="formLabelWidth">
          <div>{{form.reason}}</div>
        </el-form-item>
        <el-form-item label="商品图片：" :label-width="formLabelWidth">
          <img
            v-for="item in form.images"
            :key="item.id"
            :src="item"
            style="width:100px;height:100px"
          />
        </el-form-item>
        <el-form-item label="订单类型：" :label-width="formLabelWidth">
          <div>{{form.order_type}}</div>
        </el-form-item>
        <el-form-item label="退款金额：" :label-width="formLabelWidth">
          <div>{{form.refund_fee/100}}</div>
        </el-form-item>
        <el-form-item label="退款状态：" :label-width="formLabelWidth">
          <div>{{form.status}}</div>
        </el-form-item>
        <el-form-item label="创建时间：" :label-width="formLabelWidth">
          <div>{{form.created_at}}</div>
        </el-form-item>
        <el-form-item label="修改时间：" :label-width="formLabelWidth">
          <div>{{form.updated_at}}</div>
        </el-form-item>
        <!-- client_id: 48685619479040
nick_name: "YUZH"
order_id: 144861624533248
order_type: "外卖"
shop_id: 25884083765760
        updated_at: "2020-09-13T01:30:38+08:00"-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="noStatus()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date';

export default {
  name: 'employee',
  data() {
    return {
      formInline: {},
      typeDate: [],
      statusList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      tableData: [],
      dialogFormVisible: false,
      form: [],
      formLabelWidth: '200px',
      total: 0,
      page_size: 20,
      page_no: 1,
    };
  },
  methods: {
    deleteLaole(id) {
      this.$confirm('此操作将完成退款, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const url = this.$userList.user_order_search_refund_confirm;
        const data = {
          refund_id: id,
          success: true,
        };
        this.$http.post(url,data).then(res => {
          if (res.code === 200) {
            this.getList();
            return;
          }
          if (res.code !== 200) {
            this.$alert('删除失败');
          }
        });
      });
    },
    pageSize(index) {
      this.page_no = index;
      this.getList();
    },
    noStatus() {
      this.dialogFormVisible = false;
    },
    onSubmit() {
      console.log('submit!');
      this.formInline = {};
      this.getList();
    },
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },

    getList() {
      const url = this.$userList.user_order_search_refund;
      const data = {
        client_nick_name: this.formInline.client_nick_name || '',
        mobile: this.formInline.mobile,
        // start_date: (this.formInline.date && this.formInline.date[0]) || '',
        // end_date: (this.formInline.date && this.formInline.date[1]) || '',
        page_index: this.page_no,
        page_size: this.page_size,
        shop_id: this.formInline.shop_id,
        status: this.formInline.status,
      };
      if(this.formInline && this.formInline.date && this.formInline.date.length>0){
            data.start_date=fecha.format(
              new Date(this.formInline.date[0]),
              'yyyy-MM-dd HH:mm:ss'
            )
              data.end_date=fecha.format(
              new Date(this.formInline.date[1]),
              'yyyy-MM-dd HH:mm:ss'
            )
        }
      // "status": "",

      this.$http.post(url, data).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.items;
          if (this.tableData.length) {
            this.tableData = this.tableData.map(item => {
              item.created_at = fecha.format(
                new Date(item.created_at),
                'yyyy-MM-dd HH:mm:ss'
              );
              item.updated_at = fecha.format(
                new Date(item.updated_at),
                'yyyy-MM-dd HH:mm:ss'
              );
              return item;
            });
          }

          this.total = res.data.count;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    //获取门店
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.typeDate = res.data.items;
          this.formInline.shop_id = res.data.items[0].id;
          this.getList();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    //通用状态
    getCommonData() {
      const url = this.$userList.user_common_data + `/order_status`;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          this.statusList = res.data.filter(item => {
            if (
              item.value !== '已支付' &&
              item.value !== '未支付' &&
              item.value !== '支付失败'
            ) {
              return item;
            }
          });
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    refundValue(id) {
      console.log(id);
      const url = this.$userList.user_order_search_refund_value + `/` + id;
      this.$http.get(url).then(res => {
        if (res.code === 200) {
          let data = res.data;
          // data.map(item => {
          data.created_at = fecha.format(
            new Date(data.created_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          data.updated_at = fecha.format(
            new Date(data.updated_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          // });
          (data.takeout_type =
            (data.takeout_type == 'deliver' && '外卖') || '自提'),
            (this.form = data);
          this.dialogFormVisible = true;

          console.log(data);
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
  },
  created() {
    this.$root.setheadName();
    this.getType();
    this.getCommonData();
    // this.getMuList();
  },
};
</script>

<style   scoped>
#basic {
  width: 100%;
  height: 100%;
  position: relative;
}

.top_div {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 20px;
  background: #fff;
}

.demo-form-inline {
  display: flex;
  justify-content: flex-start;
}

/* .el-select > .el-input,
.el-input__inner {
  width: 300px;
} */
.vubutton {
  background: #fff;
  border: solid 1px #1890ff;
  color: #1890ff;
}

.center_div {
  margin-top: 20px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}

.center_div_border {
  margin-top: 20px;
  width: 100%;
  min-height: 300px;
  background: brown;
}

.bottom_center {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
